<div class="container-fluid">
  <div>
    <div class="list-detail-top mt-2">
      <div>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" :disabled="!measureId || !projectId"
          @click="openNoteModal">
          {{ $t('message.button_vehicle_dtc_note_modal') }}
        </b-button>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" :disabled="!measureId" @click="csvExport">
          {{ $t('message.file_export') }}
        </b-button>
      </div>
      <div>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" :disabled="!measureId" @click="reGetReadinessStatus">
          {{ $t('message.button_vehicle_dtc_gain_again') }}
        </b-button>
      </div>
    </div>
  </div>

  <cstm-table useStripeStyle useSort hasTabs rowSelect initSortDir="asc" :items="readinessStatusResultItems"
    :columns="readinessStatusResultColumns" class="mt-2 ml-2 dtc-cstm-table" type="simple" currentSortkey="readinessGroup">
  </cstm-table>

  <!-- メモ画面 -->
  <b-modal v-model="modalMemo" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_vehicle_dtc_note_modal') }}
      </div>
    </template>

    <memo-page v-if="modalMemo" ref="memo"
      :projectId="projectId"
      :measureId="measureId"
      :functionNameKey="functionNameKey"
      :obdFunctionLabelKey="obdFunctionLabelKey"
      @closeNoteModal="closeNoteModal"
      :modalLoading="isMemoDialogLoading" @update-loading="isMemoDialogLoading = $event"
      :destinationAPI="destinationAPI"
    />

    <template v-slot:footer>
      <button type="button" :disabled="isMemoDialogLoading" v-on:click="memoClear()"
        class="btn clear-button ml-3 btn-outline-primary btn-sm rounded-pill">{{ $t("message.common_button_clear") }}
      </button>
      <div class="text-center w-100">
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="outline-primary" @click="modalMemo=false" class="ml-2 mr-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="primary" @click="memoSave()" class="ml-2 mr-2">
          {{ $t('message.common_button_save') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <processing-view :processing="processing"></processing-view>
</div>